/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_SubstitutionInputs */

const en_enum_setting_group_substitution = /** @type {(inputs: Enum_Setting_Group_SubstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Substitution`)
};

const de_enum_setting_group_substitution = /** @type {(inputs: Enum_Setting_Group_SubstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe Substitution`)
};

/**
* | output |
* | --- |
* | "Group Substitution" |
*
* @param {Enum_Setting_Group_SubstitutionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_substitution = /** @type {((inputs?: Enum_Setting_Group_SubstitutionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_SubstitutionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_substitution(inputs)
	return de_enum_setting_group_substitution(inputs)
});